/**
 * A send still 'sending' this long after its claim has died with its process
 * (the longest send, 20,000 drivers at 25 a second, takes under 20 minutes):
 * the Api lets a new Send take the claim over, and the per-newsletter send
 * log skips everyone the stopped send already reached. Shared so Admin and
 * the Mcp offer Resume exactly when the Api would accept it.
 */
export const NEWSLETTER_SENDING_STALE_MS = 2 * 60 * 60 * 1000;
/** A 'sending' claim old enough to take over: the send stopped (its Api
 *  process was replaced or died) and can be resumed. */
export function isStaleSendingClaim(s, now = new Date()) {
    if (s.status !== 'sending' || !s.sending_at)
        return false;
    const at = s.sending_at instanceof Date ? s.sending_at : new Date(s.sending_at);
    if (Number.isNaN(at.getTime()))
        return false;
    return now.getTime() - at.getTime() > NEWSLETTER_SENDING_STALE_MS;
}
/** The lead marketing lists a newsletter can target. */
export const NEWSLETTER_LEAD_AUDIENCES = [
    'newsletter', 'investor', 'sales_partner', 'sales_ops', 'social', 'mission_hills_investors',
];
export const DRIVER_V1_PLACE_FILTERS = ['none', 'station', 'operator', 'any'];
//# sourceMappingURL=newsletter.js.map